import { AddressModel, DefendantModel, TelephoneModel } from '@src/model/interface';
import { ApiV2Service } from '@src/service/api-v2.service';
import { KbaResultEnum } from '@enum';

export enum CheckboardSoftCheckQuestionChoiceTypeEnum {
  SINGLE_CHOICE = 'SINGLE_CHOICE',
}

export interface CheckboardSoftCheckChoiceModel {
  choiceId: number;
  choiceText: string;
}

export interface CheckboardSoftCheckQuestionModel {
  questionId: number;
  questionText: string;
  choiceType: {
    type: CheckboardSoftCheckQuestionChoiceTypeEnum;
  };
  choices: CheckboardSoftCheckChoiceModel[];
  note: string;
}

export interface CheckboardQAModel {
  [questionId: number]: number[];
}

export interface InviteKBAClientCheckLeadModel {
  email: string;
  resumeKey: string;
  firstName: string;
  lastName: string;
  dob: string;
  telephone: TelephoneModel;
  address: AddressModel;
  previousAddresses?: AddressModel[];
  introducerId: number;
}

export interface CompleteSoftCheckLeadModel {
  resumeKey: string;
  defendantIdsInSelectedMappings: number[];
  referenceId: string;
  answers: CheckboardQAModel;
  introducerId: number;
}

export interface CheckboardInitQAModel {
  kbaResult?: KbaResultEnum;
  detailsMismatch?: boolean;
  notFound?: boolean;
  referenceId?: string;
  questions?: CheckboardSoftCheckQuestionModel[];
}

export class CheckboardService extends ApiV2Service {
  // You are not supposed to instantiate this class using new
  private constructor() {
    super();
  }

  static serviceName = 'CheckboardService';
  static baseUrl = process.env.CBS_URL || 'https://jirlpg3ew9.execute-api.eu-west-1.amazonaws.com';

  protected static logger = (...args: any[]) => {
    if (this.environment === 'dev') {
      console.log(`%c[${this.serviceName}] :: `, 'color:DodgerBlue', args.join(''));
    }
  };

  static inviteClientKBACheck(lead: InviteKBAClientCheckLeadModel): Promise<CheckboardInitQAModel> {
    return this.post<CheckboardInitQAModel>('invite-kba', { lead });
  }

  static completeClientSoftCheck(completeSCM: CompleteSoftCheckLeadModel): Promise<{ creditCheckRef: string; kbaResult: KbaResultEnum }> {
    return this.post<{ creditCheckRef: string; kbaResult: KbaResultEnum }>('complete-kba', completeSCM);
  }
}
